import { setupWindowManagerOnMessage } from './WindowManager/windowManager';

export default function loginInit() {
  setupWindowManagerOnMessage();
}



// WEBPACK FOOTER //
// ./logic/index.js